export default [{
  path: 'vehicleSignOffManage',
  name: 'vehicleSignOffManage',
  component: function component() {
    return import('@/views/vehicleSignOffManage/list');
  }
}, {
  path: 'vehicleSignOffManageAdd',
  name: 'vehicleSignOffManageAdd',
  component: function component() {
    return import('@/views/vehicleSignOffManage/add');
  }
}, {
  path: 'vehicleSignOffManageDetail',
  name: 'vehicleSignOffManageDetail',
  component: function component() {
    return import('@/views/vehicleSignOffManage/detail');
  }
}, {
  path: 'vehicleSignOffManageUpdate',
  name: 'vehicleSignOffManageUpdate',
  component: function component() {
    return import('@/views/vehicleSignOffManage/update');
  }
}];